module.exports = __webpack_public_path__ + "img/profle.dcf2bc99.svg";